import { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const getTaskNotes = async ({ status, taskId, page, recordsPerPage }: JsonDataItem) => {
  const data = await baseQuery(
    `task/notes?status=${status}&task_ID=${taskId}&page=${page || 1}&per_page=${recordsPerPage || 1000}`,
  );
  return data;
};
